import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';

// ES6 class-style
class ProductBanner extends PreLoginSessionCheck {
  render() {
  	return(
  		<section className={this.props.classes}>
		 	<div className="container"> 
		 	 	<h3>{this.props.name} <span>{this.props.text}</span></h3>   
		 	 	<div className="self-pross">
					<span>{this.props.bannerPoint1}</span>
					<span>{this.props.bannerPoint2}</span>
					<span>{this.props.bannerPoint3}</span>
				</div>
		 	</div> 
		</section>
  	);
  }
}

export default ProductBanner;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/ProductBanner.js